import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { treatExperiment } from '#src/app/shared/api/experiments';
import { isMobile } from '#src/app/shared/utils/userAgent';

import type { PsfPromoteOrShareDataQuery } from '../api.graphql';

type Experiment = PsfPromoteOrShareDataQuery['experiments']['psfComboRemoveAutoProgressionExperiment'];

type Params = {
	experiment: Experiment;
	utilityContext: UtilityContext;
	isShareSlideUpEnabled: boolean;
};

export async function normalizePsfComboRemoveAutoProgressionExperiment({
	experiment,
	utilityContext,
	isShareSlideUpEnabled,
}: Params): Promise<Experiment> {
	if (shouldRunExperiment({ experiment, utilityContext, isShareSlideUpEnabled })) {
		await treatExperiment(utilityContext, experiment.experimentName);
		return { ...experiment, treated: true };
	}
	return { ...experiment, variation: 'control', treated: false };
}

function shouldRunExperiment({ experiment, utilityContext, isShareSlideUpEnabled }: Params): boolean {
	return isEnabledByFC(experiment) && isMobile(utilityContext) && isShareSlideUpEnabled;
}

/**
 * Returns false when FCM is not configured or the experiment name is invalid,
 * per the configuration in packages/experiments/src/configs/configs/psf_combo_remove_auto_progression_experiment.ts
 */
function isEnabledByFC(experiment: Experiment): boolean {
	return experiment.experimentName !== '__invalid_experiment__';
}
